import {
  CREATE_CIRCULAR_REQUEST,
  CREATE_CIRCULAR_SUCCESS,
  CREATE_CIRCULAR_FAILURE,
} from "./actionTypes";

export const createCircularRequest = (payload) => ({
  type: CREATE_CIRCULAR_REQUEST,
  payload,
});

export const createCircularSuccess = (response) => ({
  type: CREATE_CIRCULAR_SUCCESS,
  payload: response,
});

export const createCircularFailure = (error) => ({
  type: CREATE_CIRCULAR_FAILURE,
  payload: error,
});
